import AffiliateMarketing from '../views/affiliate/Marketing.vue';
import AffiliatePartner from '../views/affiliate/Partner.vue';
import AffiliateDashboard from '../views/affiliate/Dashboard.vue';
import AffiliateDashboardOrders from '../views/affiliate/Orders.vue';
import AffiliateDashboardInvoices from '../views/affiliate/Invoices.vue';
import { checkauth } from '../Helper';

// schede banner e partner: pagine proprie (prima erano modali sopra la lista)
const AffiliateMarketingCreate = () => import('../views/affiliate/MarketingCreate.vue');
const AffiliateMarketingEdit = () => import('../views/affiliate/MarketingEdit.vue');
const AffiliatePartnerCreate = () => import('../views/affiliate/PartnerCreate.vue');
const AffiliatePartnerEdit = () => import('../views/affiliate/PartnerEdit.vue');

function guard(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{ path: '/affiliate/marketing/new', name: 'affiliate-marketing-new', component: AffiliateMarketingCreate, beforeEnter: guard },
	{ path: '/affiliate/marketing/:id([0-9a-fA-F]{24})', name: 'affiliate-marketing-edit', component: AffiliateMarketingEdit, beforeEnter: guard },
	{ path: '/affiliate/partner/new', name: 'affiliate-partner-new', component: AffiliatePartnerCreate, beforeEnter: guard },
	{ path: '/affiliate/partner/:id([0-9a-fA-F]{24})', name: 'affiliate-partner-edit', component: AffiliatePartnerEdit, beforeEnter: guard },
	{
		path: '/affiliate/marketing',
		name: 'affiliate-marketing',
		component: AffiliateMarketing,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/affiliate/partner',
		name: 'affiliate-partner',
		component: AffiliatePartner,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/affiliate/dashboard',
		name: 'affiliate-dashboard',
		component: AffiliateDashboard,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/affiliate/dashboard/:id/orders',
		name: 'affiliate-dashboard-orders',
		component: AffiliateDashboardOrders,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/affiliate/dashboard/:id/invoices',
		name: 'affiliate-dashboard-invoices',
		component: AffiliateDashboardInvoices,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
];
